/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventAttendeeStatus = "ATTENDING_IN_PERSON" | "ATTENDING_VIRTUAL" | "NOT_ATTENDING" | "WAITING_IN_PERSON" | "%future added value";
export type EventScreenDateTime_event = {
    readonly slug: string;
    readonly startAt: string;
    readonly endAt: string;
    readonly timeZone: string;
    readonly hasExternalUrl: boolean | null;
    readonly myAttendance: {
        readonly status: EventAttendeeStatus;
    } | null;
    readonly " $refType": "EventScreenDateTime_event";
};
export type EventScreenDateTime_event$data = EventScreenDateTime_event;
export type EventScreenDateTime_event$key = {
    readonly " $data"?: EventScreenDateTime_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventScreenDateTime_event">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenDateTime_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "timeZone",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasExternalUrl",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EventAttendee",
      "kind": "LinkedField",
      "name": "myAttendance",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "status",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
(node as any).hash = 'a588179c2f390e0e0d513863ad60b6c1';
export default node;
